// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom"; // Import the useNavigate hook for navigation
// import "./SchoolAllClasses.css"; // Import the CSS file

// const AllClasses = () => {
//   const [schoolClassName, setSchoolClassName] = useState([]);

//   const navigate = useNavigate();

//   const handleAddNewClass = () => {
//     navigate("/school-add-class");
//   };
//   const handleViewAllClasses = () => {
//     navigate("/school-all-class");
//   };

//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   // CLASSES DATA GET FUN AXIOS --
//   const getClasses = () => {
//     axios
//       .get(`${API_BASE_URL}/classes`)
//       .then((resp) => {
//         const { data } = resp.data;
//         setSchoolClassName(data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };
//   useEffect(() => {
//     getClasses();
//   }, []);

//   // API DELETE FUN
//   let handleSchoolClassDlt = async (id) => {
//     let dltOrNot = window.confirm("Do you want to delete");
//     if (dltOrNot) {
//       axios.delete(`${API_BASE_URL}/classes/${id}`).then((resp) => {
//         console.log(resp);
//         getClasses();
//       });
//     }
//   };

//   const handleEdit = (id) => {
//     // alert(id);
//     navigate(`/school-edit-class/${id}`);
//   };

//   return (
//     <>
//       <div id="classes-inner-wrapper">
//         <div className="classes-header-div">
//           <h5>Classes</h5>
//           <div className="classes-header-btns">
//             <button className="add-class-btn" onClick={handleAddNewClass}>
//               + Add New Class
//             </button>
//             <button className="all-classes-btn" onClick={handleViewAllClasses}>
//               All Classes
//             </button>
//           </div>
//         </div>

//         <div className="classes-table-container">
//           <h5>All Classes</h5>
//           <table className="classes-table">
//             <thead>
//               <tr>
//                 <th>S.No.</th>
//                 <th>Class</th>
//                 <th>Category</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {schoolClassName.map((classes, idx) => (
//                 <tr key={classes._id}>
//                   <td>{idx + 1}</td>
//                   <td>{classes.className}</td>
//                   <td>
//                     {classes?.category && classes?.category.length > 0
//                       ? classes?.category.map((item) => <p>{item}</p>)
//                       : "N/A"}
//                   </td>
//                   <td className="table-action-icons">
//                     <i
//                       className="fa-solid fa-file-pen"
//                       onClick={() => handleEdit(classes._id)}
//                     ></i>
//                     <i
//                       className="fa-solid fa-trash-can"
//                       onClick={() => handleSchoolClassDlt(classes._id)}
//                     ></i>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AllClasses;







import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./SchoolAllClasses.css";

const AllClasses = () => {
  const [classesData, setClassesData] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  /* ================= FETCH CLASSES ================= */

  const getClasses = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/classes`,
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      setClassesData(response.data.data || []);
    } catch (error) {
      Swal.fire(
        "Error",
        "Failed to fetch classes",
        "error"
      );
    }
  };

  useEffect(() => {
    getClasses();
  }, []);

  /* ================= DELETE CLASS ================= */

  const handleSchoolClassDlt = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.delete(
          `${API_BASE_URL}/classes/${id}`,
          {
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        Swal.fire(
          "Deleted!",
          "Class deleted successfully.",
          "success"
        );

        getClasses();
      } catch (error) {
        Swal.fire(
          "Error",
          error.response?.data?.msg ||
            "Failed to delete class",
          "error"
        );
      }
    }
  };

  /* ================= NAVIGATION ================= */

  const handleAddNewClass = () => {
    navigate("/school-add-class");
  };

  const handleEdit = (id) => {
    navigate(`/school-edit-class/${id}`);
  };

  return (
    <div id="classes-inner-wrapper">
      <div className="classes-header-div">
        <h5>Classes</h5>

        <div className="classes-header-btns">
          <button
            className="add-class-btn"
            onClick={handleAddNewClass}
          >
            + Add New Class
          </button>
        </div>
      </div>

      <div className="classes-table-container">
        <h5>All Classes</h5>

        <table className="classes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Class</th>
              <th>Board</th>
              <th>Category</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {classesData.length > 0 ? (
              classesData.map((item, idx) => (
                <tr key={item._id}>
                  <td>{idx + 1}</td>
                  <td>{item.className}</td>

                  {/* Board Name */}
                  <td>
                    {item.board?.boardName || "N/A"}
                  </td>

                  {/* Category */}
                  <td>
                    {item.category?.length > 0 ? (
                      item.category.map((cat, index) => (
                        <span
                          key={index}
                          className="category-badge"
                        >
                          {cat.replaceAll("_", " ")}
                        </span>
                      ))
                    ) : (
                      "N/A"
                    )}
                  </td>

                  {/* Actions */}
                  <td className="table-action-icons">
                    <i
                      className="fa-solid fa-file-pen edit-icon"
                      onClick={() => handleEdit(item._id)}
                    ></i>

                    <i
                      className="fa-solid fa-trash-can delete-icon"
                      onClick={() =>
                        handleSchoolClassDlt(item._id)
                      }
                    ></i>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No Classes Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllClasses;